/**
 * this is school information
 *
 * @parent routes
 * @children
 * @stateful
 */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import SchoolInformationForm from './SchoolInformationForm';
import PanelWrapper from 'components/UI/PanelWrapper';

const mapStateToProps = state => ({
	all: state
});

const mapDispatchToProps = dispatch => {
	return {
	};
};

class SchoolInformation extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<PanelWrapper>
        <SchoolInformationForm />
			</PanelWrapper>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolInformation);



// WEBPACK FOOTER //
// ./src/containers/pages/SchoolInformation/SchoolInformation.js